<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="LocationtagViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{locationtag.name}}</p>
                <p>ID: {{locationtag['.key']}}</p>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../../elements/Form/FormText'
import database from '../../../webmaster/Database/database'
import store from '../../../webmaster/Store/vuex'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'editlocationtag',
  components:{
    'form-text':FormText,
  },
  data () {
    return {
      org: store.state.usermain,
      locationtag:{},
      locationtagEdit:{},
      isEditing: false,
    }
  },
  created:function(){
    this.fetchLocationtag()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    fetchLocationtag: function(){
      this.$bindAsObject('locationtag', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/devices/' + this.$route.params.id), null, function(){
        this.locationtagEdit = Object.assign({}, this.locationtagEdit, this.locationtag);
      });
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        this.updateTag(database.getDb().ref(), self.$store.state.usermain.curOrg.id, self.locationtag['.key'], self.locationtag.name, self.locationtag.props.tagid).then(_ => {
          this.locationtag = Object.assign({}, this.locationtag, this.locationtagEdit);
          self.isEditing = false;
        }).catch(err => {
          console.log(err)
        });
      }, () => {});
    },
    updateTag: function(rootRef, org, deviceId, name, tagid){
      let updateObj = {}
      updateObj['/orgs/' + org + '/devices/' + deviceId + '/name'] = name
      updateObj['/orgs/' + org + '/devices/' + deviceId + '/props/tagid'] = tagid
      return rootRef.update(updateObj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// EditLocationTag.vue?359a7a0d